import { ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { isNullish } from '@commonHelpers/math-utils';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from '@ngx-translate/core';
import { globalEnvironment } from '@environments/globalEnvironment';
import { HelpdeskService } from '@services/helpdesk.service';
import { TranslationService } from '@services/translation.service';

@Component({
	selector: 'app-help-public',
	templateUrl: './help-public.component.html',
	styleUrls: ['./help-public.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, TranslatePipe]
})
export class HelpPublicComponent {
	@ViewChild("helpDropdown") helpDropdown: NgbDropdown;

	constructor(private helpdeskService: HelpdeskService, private translationService: TranslationService) { }

	public onHoverDropdown() {
		this.helpDropdown.open()
	}

	public onLeaveDropdown() {
		this.helpDropdown.close()
	}

	public async openHelpdesk() {
		let helpdeskUrl = await this.helpdeskService.getHelpdeskRoute(globalEnvironment.helpdeskHeader.solution, globalEnvironment.helpdeskHeader.helpId);

		if (isNullish(helpdeskUrl)) {
			return;
		}

		// Spracheinstellung anfügen
		helpdeskUrl += (helpdeskUrl.includes("?") ? "&" : "?") + "lang=" + this.translationService.getLanguage();

		window.open(helpdeskUrl, "_blank");
	}
}
